import { Button, Modal } from 'antd';
import React from 'react';
import { useNotify } from 'react-admin';
import { CopyOutlined } from '@ant-design/icons';
import yaml from 'js-yaml';
import CodeEditorSheet, { codeModalProps } from '@src/components/Common/CodeEditorSheet';

/**
 * The application as it would appear in a declaration file — read-only, in the
 * same sheet the metadata is edited in, so the YAML you look at and the YAML
 * you write are recognisably the same kind of thing.
 */
const ApplicationYAMLModal = ({ modalVisible, setModalVisible, appName, appDeclarationData }: { modalVisible: boolean, setModalVisible: Function, appName: string, appDeclarationData: any }) => {
    const notify = useNotify();
    const source = yaml.dump({ [appName]: appDeclarationData });

    const onCopy = () => {
        navigator.clipboard.writeText(source);
        notify('Copied to clipboard');
    };

    return (
        <Modal
            {...codeModalProps(`${appName}.yml`)}
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={[
                <Button key="copy" icon={<CopyOutlined />} onClick={onCopy}>
                    Copy
                </Button>,
                <Button key="close" type="primary" onClick={() => setModalVisible(false)}>
                    Close
                </Button>,
            ]}
        >
            <CodeEditorSheet
                language="yaml"
                value={source}
                readOnly
                ariaLabel={`${appName} declaration YAML`}
            />
        </Modal>
    );
};

export default ApplicationYAMLModal;
